/**
 * ReportsHarvestInspectionsAverageCountSizeCard
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Header, Segment } from 'semantic-ui-react';

// Selectors
import { makeSelectFieldAverage } from './selectors';

interface Props {
    value: number;
}

export class ReportsHarvestInspectionsAverageCountSizeCard extends React.PureComponent<Props> {
    render() {
        const { value } = this.props;
        return (
            <Segment
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 10
                }}
            >
                <Header as="h2" textAlign="center">
                    <Header.Content>
                        {value}
                        <Header.Subheader color="grey">
                            {'Avg. Count Size'}
                        </Header.Subheader>
                    </Header.Content>
                </Header>
            </Segment>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    value: makeSelectFieldAverage()
});

export default connect(mapStateToProps)(
    ReportsHarvestInspectionsAverageCountSizeCard
);
